export { default } from './CardCandidat';
